import { Library } from "lucide-react";
import { ProgressBar } from "./ProgressBar";
import { handleSetAssetError } from "../lib/images";
import { useSetAsset } from "../hooks/useSetAsset";

export const SetCard = ({ set, completion, counts, onSelect }) => {
  const cardCount = set.cardCount?.total || set.cardCount?.official || 0;
  const logoSrc = useSetAsset(set.id, "logo", set.logo);
  const symbolSrc = useSetAsset(set.id, "symbol", set.symbol);
  return (
    <div className="set-card group cursor-pointer" onClick={() => onSelect(set)}>
      <div className="relative h-32 flex items-center justify-center p-4 bg-zinc-900/80 overflow-hidden">
        {logoSrc ? (
          <img src={logoSrc} alt={set.name}
            className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-110"
            loading="lazy" decoding="async" onError={handleSetAssetError} />
        ) : (
          <Library className="w-12 h-12 text-zinc-600" />
        )}
      </div>
      <div className="p-3 border-t border-zinc-800">
        {/* Symbole de set à côté du nom (demande utilisateur du 2026-10-03 :
            « c'est comme ça qu'on connaît les séries »), plus net qu'en
            filigrane dans le coin de la vignette. */}
        <h3 className="text-sm font-semibold text-white truncate flex items-center gap-1.5" title={set.name}>
          {symbolSrc && (
            <img src={symbolSrc} alt="" className="w-7 h-7 object-contain shrink-0 drop-shadow"
              loading="lazy" decoding="async" onError={handleSetAssetError} />
          )}
          <span className="truncate">{set.name}</span>
        </h3>
        <div className="flex items-center justify-between mt-1 text-xs text-zinc-500">
          <span>
            {cardCount} cartes
            {/* Collection que TCGdex n'a qu'en anglais : on la sert quand même,
                mais autant prévenir avant d'ouvrir. */}
            {set.lang === "en" && (
              <span className="ml-1.5 text-amber-500/80" title="Aucune donnée française chez TCGdex : contenu en anglais">EN</span>
            )}
          </span>
        </div>
        <ProgressBar size="md" className="mt-2" pct={completion || 0}
          owned={counts?.owned ?? 0} total={counts?.total ?? cardCount} />
      </div>
    </div>
  );
};
